import { PrefilledLineData } from '../../types/prefilled-line/PrefilledLineData';
import { DraggableProvided } from '@hello-pangea/dnd';
import { Box, ListItemText, ListItemIcon } from '@mui/material';
import React from 'react';
import { Add } from '@mui/icons-material';

import ListItemButton from '@mui/material/ListItemButton';

export interface PrefilledLineInsertionDropCloneProps {
  item: PrefilledLineData;
  provided: DraggableProvided;
}

export const PrefilledLineInsertionDropClone = (
  props: PrefilledLineInsertionDropCloneProps,
) => {
  const { item, provided } = props;
  const refProps = { ref: provided?.innerRef };
  return (
    <Box
      boxShadow={4}
      sx={{ backgroundColor: 'success.light' }}
      {...refProps}
      {...provided?.draggableProps}
      {...provided?.dragHandleProps}
      style={{
        ...provided?.draggableProps.style,
      }}
    >
      <ListItemButton>
        <ListItemIcon>
          <Add />
        </ListItemIcon>
        <ListItemText primary={'Insérer "' + item.name + '" ici'} />
      </ListItemButton>
    </Box>
  );
};
